export class NexorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NexorError";
  }
}

export class NexorAPIError extends NexorError {
  status: number;
  code: string;
  body: unknown;
  requestId?: string;

  constructor(opts: {
    status: number;
    code?: string;
    message: string;
    body?: unknown;
    requestId?: string;
  }) {
    super(opts.message);
    this.name = "NexorAPIError";
    this.status = opts.status;
    this.code = opts.code ?? statusToCode(opts.status);
    this.body = opts.body;
    this.requestId = opts.requestId;
  }
}

export class NexorAuthError extends NexorAPIError {
  constructor(opts: { message: string; body?: unknown; requestId?: string }) {
    super({ status: 401, code: "unauthorized", ...opts });
    this.name = "NexorAuthError";
  }
}

export class NexorValidationError extends NexorAPIError {
  constructor(opts: { message: string; body?: unknown; requestId?: string }) {
    super({ status: 400, code: "validation_error", ...opts });
    this.name = "NexorValidationError";
  }
}

export class NexorNetworkError extends NexorError {
  cause?: unknown;
  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = "NexorNetworkError";
    this.cause = cause;
  }
}

function statusToCode(status: number): string {
  if (status === 400) return "validation_error";
  if (status === 401) return "unauthorized";
  if (status === 403) return "forbidden";
  if (status === 404) return "not_found";
  if (status === 409) return "conflict";
  if (status === 422) return "unprocessable_entity";
  if (status === 429) return "rate_limited";
  if (status >= 500) return "server_error";
  return "http_error";
}
